import React from 'react';
import Footer from './Footer'
import Header from './Header';

const HeaderAndFooterOnly = (props) => {
    return (
        <div>
            <Header />
            {props.children}
            <Footer />
        </div>
    );
}

export default HeaderAndFooterOnly;